import React from 'react'
import Styled, { css } from 'styled-components'

const commonStyles = css`
  @media (prefers-color-scheme: dark) {
    fill: ${p => p.fill || '#ffffff'};
  }
  @media (prefers-color-scheme: light) {
    fill: ${p => p.fill || '#000000'};
  }
`

const Path = Styled.path`
  ${commonStyles};
`
const Circle = Styled.circle`
  ${commonStyles};
`

export default ({ fill, size = '100px' } = {}) => (
  <svg width={ size } height={ size } fill={ fill } viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" strokeWidth="1" >
      <rect strokeOpacity="0" stroke="#FFFFFF" fillOpacity="0" x="0.5" y="0.5" width="99" height="99"></rect>
      <g transform="translate(10.000000, 10.000000)" fill={ fill }>
        <Path d="M54.9001289,0.685714286 L25.2751289,0.685714286 C11.6426914,0.685714286 0.587628866,11.7407768 0.587628866,25.3732143 L0.587628866,54.9982143 C0.587628866,68.6306518 11.6426914,79.6857143 25.2751289,79.6857143 L54.9001289,79.6857143 C68.5325664,79.6857143 79.5876289,68.6306518 79.5876289,54.9982143 L79.5876289,25.3732143 C79.5876289,11.7407768 68.5325664,0.685714286 54.9001289,0.685714286 Z M72.1813789,54.9982143 C72.1813789,64.5275893 64.4295039,72.2794643 54.9001289,72.2794643 L25.2751289,72.2794643 C15.7457539,72.2794643 7.99387887,64.5275893 7.99387887,54.9982143 L7.99387887,25.3732143 C7.99387887,15.8438393 15.7457539,8.09196429 25.2751289,8.09196429 L54.9001289,8.09196429 C64.4295039,8.09196429 72.1813789,15.8438393 72.1813789,25.3732143 L72.1813789,54.9982143 Z" />
        <Path d="M39.5876289,19.6857143 C28.5426289,19.6857143 19.5876289,28.6407143 19.5876289,39.6857143 C19.5876289,50.7307143 28.5426289,59.6857143 39.5876289,59.6857143 C50.6326289,59.6857143 59.5876289,50.7307143 59.5876289,39.6857143 C59.5876289,28.6407143 50.6326289,19.6857143 39.5876289,19.6857143 Z M39.5876289,52.1857143 C32.6976289,52.1857143 27.0876289,46.5757143 27.0876289,39.6857143 C27.0876289,32.7907143 32.6976289,27.1857143 39.5876289,27.1857143 C46.4776289,27.1857143 52.0876289,32.7907143 52.0876289,39.6857143 C52.0876289,46.5757143 46.4776289,52.1857143 39.5876289,52.1857143 Z" />
        <Circle cx="60.5876289" cy="18.6857143" r="3"/>
      </g>
    </g>
  </svg>
)
